import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSupplierInfo } from '../../../../store/slices/supplierInfoSlice';
import { useSectionNumbering } from '../hooks/useSectionNumbering';
import InfoRow from './InfoRow';
import InfoSection from './InfoSection';

const PerformanceOverviewSection = () => {
    const { t } = useTranslation();
    const { sectionNumbers } = useSectionNumbering();
    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts } = supplierInfo || { amounts: {} };

    return (
        <>
            <InfoSection>
                <InfoRow
                    label={`${sectionNumbers.totalPerformance}. ${t('supplier-info.total-performance')}`}
                    value={amounts?.invoiceTotalAmount || 0}
                    name="totalAmount"
                    suffix='€'
                />
                <InfoRow
                    label={<b>{sectionNumbers.testResultNet}. {t('supplier-info.test-result-net')}</b>}
                    value={amounts?.invoiceAufmassTotalAmount || 0}
                    name="aufmassTotalAmount"
                    suffix='€'
                    isBold={true}
                />
            </InfoSection>
        </>
    );
};

export default PerformanceOverviewSection;
